import { Component, ElementRef, ViewChild , Input, Output, EventEmitter } from '@angular/core';
import { environment } from '@unico-people/shared/utils/environments';
import { getTokenStorage, SessionStorage } from '@unico-people/shared/utils/storage';

@Component({
    selector: 'envelope-simple-shipping',
    templateUrl: './envelope-simple-shipping.component.html'
})
export class EnvelopeSimpleShippingComponent {
    @Input() document: any;
    @ViewChild('octopus') elOctopus:ElementRef;
    @Output() closeShipping = new EventEmitter<boolean>();
    contactsList: any;
        contacts = [];

    config = {
      accessToken: getTokenStorage(),
      productId: environment.productId,
      baseUrl: environment.base_sign_url
    }

    constructor() {
        document.addEventListener('octopusEventListener', this.octopusClickHandler.bind(this));
    }

    ngAfterViewInit() {
        this.elOctopus.nativeElement.setAttribute('config', JSON.stringify(this.config));
        this.contactsList = SessionStorage.getItem('contactsList');
        if (this.contactsList && this.contactsList.length > 0) {
            this.elOctopus.nativeElement.setAttribute('contacts-list', JSON.stringify(this.contactsList));
        }
    }

    octopusClickHandler(event: any): void {
        if ( event?.detail?.status === 'cancel' ||
            event?.detail?.status === 'success' ||
            event?.detail?.status === 'error' ) {
            this.closeShipping.emit();
        }
    }
}
